import { memo } from "react";
import cn from "classnames";
import { Button, Text } from "../../../../packages/ui-kit";
import { LinkIcon } from "../../../../packages/icons";
import { helpers } from "../../../../packages/helpers";
import { isButtonLink } from "../../type-guards";
import { useMessageButtons } from "./use-message-buttons";
import { ChatMessageReply } from "./chat-message-reply";
import type { MessageButtons } from "../../types";
import styles from "./message-kinds.module.scss";

const { linkInText } = helpers.text;

type Props = {
  dataTestId?: string;
  className?: string;
  message: MessageButtons;
};

export const ChatMessageButtons = memo(
  ({
    dataTestId = "message-content-button-container",
    className,
    message,
  }: Readonly<Props>) => {
    const { isLastMessage, handleButtonClick } = useMessageButtons(message);
    const { buttons, text } = message.content;

    const replyMessage = (
      <ChatMessageReply parentId={message.id} message={message.replyMessage} />
    );

    const textComponent = (
      <Text
        dataTestId="message-content-text"
        className={styles["message-text"]}
      >
        {/* TODO удалить при реализации entity*/}
        <span dangerouslySetInnerHTML={{ __html: linkInText(text) }} />
      </Text>
    );

    const buttonsList = (
      <ul
        data-test-id="message-content-buttons"
        className={styles["message-buttons"]}
      >
        {buttons.map((line, index) => (
          <li
            key={index}
            data-test-id="message-content-buttons-line"
            className={styles["button-row"]}
            style={{ gridTemplateColumns: `repeat(${line.length}, 1fr)` }}
          >
            {line.map((button) => (
              <Button
                dataTestId={`message-content-buttons-line-button:${button.title}`}
                className={cn(styles.button)}
                key={button.title}
                size="small"
                type="outline"
                onClick={handleButtonClick(button)}
              >
                <div className={styles["button-content"]}>{button.title}</div>
                {isButtonLink(button) && (
                  <span className={styles["link-icon"]}>
                    <LinkIcon />
                  </span>
                )}
              </Button>
            ))}
          </li>
        ))}
      </ul>
    );

    return (
      <>
        <div data-test-id={dataTestId} className={className}>
          {replyMessage}
          {textComponent}
        </div>
        {isLastMessage && buttonsList}
      </>
    );
  }
);
